import React from 'react';
import './style.css';
import {isMobile} from '../helpers/utils';

const SMSDisclosures = props => (
    <div className="sms-disclosures">
        <h2>Text Messaging Services</h2>
        <div className={isMobile()?"disclosure-statement" : '' }>
            SMS Service is provided by Regions subject to the terms and conditions of the  
            &nbsp;
            {/* <a 
            target="_blank" 
            rel="noopener noreferrer" 
            className="App-Link" 
            href=" https://www.regions.com/digital-banking/electronic-banking-service-agreement">
            &nbsp; */}
            Agreement and Disclosure Statement for Electronic Banking Services<sup>1</sup> (the “Agreement”).
            {/* </a> */}
            {/* (the “Agreement”).  In addition to the Agreement, please be mindful of the following important information about SMS Service: */}
            <br /><br />
            In addition to the Agreement, please be mindful of the following important information about SMS Service:
        </div>
        <div className="command">
            <div className="command-block">
                <div className={isMobile()? "command-block-command" : "learn-more-web"}>
                    <label>Cost to Participate:</label>
                    <span>Regions does not charge a fee for using the SMS Service. However, message
                    and data rates may apply. Check your mobile phone or wireless plan for details. Message
                    frequency depends on account settings.
                    </span>
                </div>
            </div>
            <div className="command-block">
                <div className={isMobile() ? "command-block-command" :  "learn-more-web"}>
                    <label>Questions:</label>
                    <span>You can Message Us or call 1-800-472-2265. At any time, you
                    can text HELP to 734265.
                    </span>
                </div>
            </div>
            <div className="command-block">
                <div className={isMobile() ? "command-block-command" :  "learn-more-web"}>
                    <label>To Stop the SMS Service:</label>
                    <span>You may cancel the SMS Service at any time. To cancel the SMS Service
                    via SMS, text STOP to 734265. You’ll receive a one-time opt-out confirmation text message, and after that you will not receive any
                    future SMS messages.
                    </span>
                </div>
            </div>
            <div className="command-block">
                <div className={isMobile() ? "command-block-command" :  "learn-more-web"}>
                    <label>Carriers Supported:</label>
                    <span>SMS Service may not be available through all mobile service providers and
                    carriers.  Carriers Supported: Sprint, T-Mobile®, Verizon Wireless, Virgin Mobile USA, Nextel/Boost, AT&T, U.S. Cellular®, MetroPCS, and Cricket Wireless. Supported carriers are subject to change from time to time without notice.
                    {/* To determine currently supported mobile carriers, please visit our  */}
                    {/* <a 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="App-Link" 
                    href="https://www.regions.com/help/online-banking-help/manage-accounts/alerts/what-carriers-are-supported-for-sms-text-messaging">
                    FAQ</a> page. */}
                    </span>
                </div>
            </div>
        </div>
        
        <div className="disclosure-statement">
            <br/>
            <sup >1</sup>Agreement and Disclosure located in About Us in the app menu or on Regions.com
        </div>
        
    </div>
);

export default SMSDisclosures;
